var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.794 9.491l.719.719a4.064 4.064 0 0 1 0 5.733l-2.875 2.875a4.038 4.038 0 0 1-2.866 1.18 4.038 4.038 0 0 1-2.867-1.18l-.719-.727a4.057 4.057 0 0 1 0-5.733l1.625-1.625c-.023.82.125 1.64.46 2.406l-.655.656a2.032 2.032 0 0 0 0 2.867l.718.718c.383.375.89.586 1.438.586a2.04 2.04 0 0 0 1.437-.586l2.866-2.874a2.032 2.032 0 0 0 0-2.867l-.718-.718a1.988 1.988 0 0 0-.414-.313c.016-.015.023-.039.039-.062l1.406-1.399c.14.102.273.211.406.344zM15.231 4c1.04 0 2.078.39 2.867 1.187l.719.719a4.064 4.064 0 0 1 0 5.733l-1.633 1.633a5.469 5.469 0 0 0-.453-2.414l.648-.656a2.032 2.032 0 0 0 0-2.867l-.718-.718a2.035 2.035 0 0 0-1.43-.586 2.04 2.04 0 0 0-1.437.586L10.92 9.49a2.032 2.032 0 0 0 0 2.867l.718.718c.125.125.274.22.422.313-.016.016-.023.039-.047.062l-1.398 1.399c-.133-.11-.281-.211-.406-.344l-.719-.719c-1.578-1.57-1.578-4.155 0-5.733l2.867-2.875A4.042 4.042 0 0 1 15.23 4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.9939e502f839ddd1cf79eeb5ebfb08af.svg";
export { ForwardRef as ReactComponent };